/* global tizen, webOS, webapis */

function getDeviceId(successCallback, failureCallback) {
  if (getOsType() == "samsung") {
    try {
      const id = tizen.systeminfo.getCapability(
        "http://tizen.org/system/tizenid",
      );
      if (successCallback) {
        successCallback(id);
      }
    } catch (e) {
      console.log(
        "getDeviceId exception [" +
          e.code +
          "] name: " +
          e.name +
          " message: " +
          e.message,
      );
      if (failureCallback) {
        failureCallback(e);
      }
    }
  } else if (getOsType() == "lg") {
    webOS.service.request("luna://com.webos.service.sm", {
      method: "deviceid/getIDs",
      parameters: {
        idType: ["LGUDID"],
      },
      onSuccess: function(response) {
        console.log("Result: " + JSON.stringify(response));
        if (successCallback) {
          successCallback(response.idList[0].idValue);
        }
      },
      onFailure: function(error) {
        console.log("Failed to get system ID information");
        console.log("[" + error.errorCode + "]: " + error.errorText);
        if (failureCallback) {
          failureCallback(error);
        }
      },
    });
  } else {
    const id = "eclatdev-smarttv-qpoiop-pc";
    console.log("get test deviceId : ", id);
    if (successCallback) {
      successCallback(id);
    }
  }
}

function getOsType() {
  return process.env.VUE_APP_OS_TYPE;
}

function stopApplication() {
  try {
    if (window.tizen) {
      tizen.application.getCurrentApplication().exit();
    } else if (window.webOS) {
      // webOS.platformBack();
      window.open("", "_self").close();
    } else {
      window.open("", "_self").close();
    }
  } catch (e) {
    console.log(
      "stopApplication exception [" +
        e.code +
        "] name: " +
        e.name +
        " message: " +
        e.message,
    );
  }
}

function getDeviceInfo() {
  return new Promise((resolve, reject) => {
    if (getOsType() === "lg") {
      try {
        webOS.deviceInfo(function(device) {
          const urlVersion = new URLSearchParams(window.location.search).get(
            "appVersion",
          );

          const app =
            process.env.VUE_APP_SERVICE_TYPE === "NOW"
              ? "SpotvNow"
              : "SpotvNowGolf";

          if (urlVersion && urlVersion !== "-") {
            localStorage.setItem(`${app}Version`, urlVersion);
          }

          const launcherVersion =
            urlVersion || localStorage.getItem(`${app}Version`);

          resolve({
            platform: "webOS",
            manufacturer: "LG",
            modelName: device.modelName, // 제조사 모델명
            osVersion: device.sdkVersion, // webOS SDK 버전
            appVersion: launcherVersion,
          });
        });
      } catch (e) {
        console.log("getDeviceInfo(lg) exception: ", e.message);
        reject(e);
      }
    } else if (getOsType() === "samsung") {
      try {
        const model = webapis.productinfo.getRealModel(); // 제조사 모델명
        const platformVersion = tizen.systeminfo.getCapability(
          "http://tizen.org/feature/platform.version",
        ); // Tizen 플랫폼 버전 (동기)
        // config.xml 의 version 을 읽음 (동기)
        const appVersion = tizen.application.getCurrentApplication().appInfo
          .version;
        resolve({
          platform: "Tizen",
          manufacturer: "Samsung",
          modelName: model, // 제조사 모델명
          osVersion: platformVersion, // Tizen 플랫폼 버전
          appVersion, // config.xml version
        });
      } catch (e) {
        console.log("getDeviceInfo(samsung) exception: ", e.message);
        reject(e);
      }
    } else {
      const info = {
        platform: "Web",
        manufacturer: "PC",
        modelName: "-",
        osVersion: "-",
        appVersion: "-",
      };
      console.log("get PC DEV deviceInfo : ", info);
      resolve(info);
    }
  });
}

export { getDeviceId, stopApplication, getOsType, getDeviceInfo };
